import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/affiliates")({
  head: () => ({
    meta: [
      { title: "Affiliate Program — LegalDecoder" },
      {
        name: "description",
        content:
          "Earn 30% recurring commission promoting LegalDecoder to renters, freelancers, and small businesses.",
      },
      { property: "og:title", content: "Affiliate Program — LegalDecoder" },
      {
        property: "og:description",
        content: "Earn 30% recurring commission promoting LegalDecoder.",
      },
      { property: "og:url", content: "https://legaldecoder.io/affiliates" },
    ],
    links: [{ rel: "canonical", href: "https://legaldecoder.io/affiliates" }],
  }),
  component: AffiliatesPage,
});

function AffiliatesPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <span className="text-xs font-bold uppercase tracking-wider text-primary">
          Partner with us
        </span>
        <h1 className="mt-3 text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
          Earn 30% recurring commission.
        </h1>
        <p className="mt-6 text-lg text-muted-foreground">
          Help your audience sign with confidence and get paid for every Premium subscription you
          refer — for as long as they stay subscribed.
        </p>

        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          {[
            { stat: "30%", label: "Recurring commission" },
            { stat: "60 days", label: "Cookie window" },
            { stat: "$50", label: "Minimum payout" },
          ].map((item) => (
            <div key={item.label} className="rounded-2xl border border-border bg-card p-6">
              <div className="text-3xl font-bold text-foreground">{item.stat}</div>
              <div className="mt-1 text-sm text-muted-foreground">{item.label}</div>
            </div>
          ))}
        </div>

        <section className="mt-12 space-y-4">
          <h2 className="text-2xl font-semibold text-foreground">Who it's for</h2>
          <ul className="list-disc space-y-2 pl-6 text-muted-foreground">
            <li>Personal finance and renter-advice creators</li>
            <li>Freelance and creator-economy newsletters</li>
            <li>Small business and startup community leaders</li>
            <li>Legal-adjacent bloggers and YouTubers</li>
          </ul>
        </section>

        <div className="mt-12 flex flex-wrap gap-3">
          <Button variant="hero" size="lg" asChild>
            <a href="mailto:affiliates@legaldecoder.io?subject=Affiliate%20Program%20Application">
              Apply now
            </a>
          </Button>
          <Button variant="outline" size="lg" asChild>
            <a href="mailto:affiliates@legaldecoder.io?subject=Affiliate%20Program%20Question">
              Ask a question
            </a>
          </Button>
        </div>

        <p className="mt-16 text-xs uppercase tracking-wider text-muted-foreground">
          Not legal advice. For informational purposes only.
        </p>
      </main>
      <Footer />
    </div>
  );
}
